import { z } from 'zod'
import { Link } from './nav'
import { taskDetailUrl } from '../lib/taskDetailPath'

const Summary = z.object({ id: z.string(), state: z.string(), reason: z.string().nullable(), source_run_id: z.string(),
  candidates: z.array(z.object({ id: z.string(), attempt: z.number(), state: z.string(), run_id: z.string(),
    proposal: z.object({ reason: z.string(), changes: z.unknown() }), review: z.object({ decision: z.string(), reason: z.string() }).nullable(),
  })),
})
export default function SessionRepairSummary({ value, projectId }: { value: unknown; projectId: string }) {
  const parsed = Summary.safeParse(value)
  if (!parsed.success) return null
  const repair = parsed.data
  return <section className="test-run-detail__followups">
    <h2>Session replay repair: {repair.state}</h2>
    {repair.reason && <p>{repair.reason}</p>}
    {repair.candidates.map(candidate => <div key={candidate.id}>
      <p><Link to={taskDetailUrl(projectId, candidate.run_id)}>Verification {candidate.attempt}</Link> — {candidate.state}</p>
      <p>{candidate.proposal.reason}</p>
      {candidate.review && <p>Review: {candidate.review.decision}. {candidate.review.reason}</p>}
      <details><summary>Proposed configuration changes</summary><pre>{JSON.stringify(candidate.proposal.changes, null, 2)}</pre></details>
    </div>)}
  </section>
}
